import BaseApi from '@/apis/base.api';
import { log } from '../../utils/logger.js';
import store from '@/store/index.js';
import i18n from '@/plugins/i18n';

/**
 * 변형 데이터 API 통신 클래스
 * 서버로 변형 데이터를 전송하고 에러 처리를 담당합니다.
 */
export class TransformationApi {
  /**
   * 이미지 좌표 업데이트 API 호출
   * @param {Array} transformationDataArray - 서버로 전송할 변형 데이터 배열
   * @returns {Promise<Object>} API 응답
   */
  async updateImageCoordinates(transformationDataArray) {
    try {
      log.info('TransformationApi', '이미지 좌표 업데이트 API 호출전', transformationDataArray);

      // 배열을 한 번에 서버로 전송
      const response = await BaseApi.post('/solar-thermal-images/adjust', transformationDataArray);

      log.info('TransformationApi', '이미지 좌표 업데이트 완료', {
        imageCount: transformationDataArray.length,
        response: response
      });

      // 성공 시 Store 업데이트
      this.updateStoreCoordinates(transformationDataArray);

      return { success: true, data: response };

    } catch (error) {
      log.error('TransformationApi', '서버 전송 실패', error);
      const message = i18n.t('alignment.serverErrorRefresh');
      const shouldRefresh = confirm(`${message}\n\n${i18n.t('alignment.confirmReload')}`);
      if (shouldRefresh) {
        window.location.reload();
      }
      return { success: false, error: error.message };
    }
  }

  /**
   * Store의 이미지 좌표 업데이트
   * @param {Array} transformationDataArray - 서버 응답 데이터 배열
   */
  updateStoreCoordinates(transformationDataArray) {

    transformationDataArray.forEach(transformation => {
      const { thermalImageId, positionCoordinates, centerCoordinate } = transformation;
      store.commit('imageAlignment/UPDATE_IMAGE_COORDINATES', {
        imageId: thermalImageId,
        coordinates: positionCoordinates,
        centerCoordinate: centerCoordinate
      });
    });
  }

}
